module.exports = __webpack_public_path__ + "static/g-44bb1ec4ef4cbf2b7f2c4f0b7a64efc9.jpg";